import type { StepProps } from '~/lib/types/netlify';
import { useTranslation } from '~/lib/hooks/useTranslation';

interface DeploymentStepsProps {
  currentStep: number;
}

export const DeploymentSteps = ({ currentStep }: DeploymentStepsProps) => {
  const { t, ready } = useTranslation(false);

  if (!ready) {
    return null;
  }

  return (
    <div className="flex items-center justify-between text-dualite-text-secondary">
      <Step step={2} currentStep={currentStep} label={t('modals.deploy.steps.createSite')} />
      <Step step={3} currentStep={currentStep} label={t('modals.deploy.steps.build')} />
      <Step step={4} currentStep={currentStep} label={t('modals.deploy.steps.deploy')} />
    </div>
  );
};

const Step = ({ step, currentStep, label }: StepProps) => {
  const isComplete = currentStep > step || (step === 4 && currentStep === 4);
  const isCurrent = currentStep === step && step !== 4;

  return (
    <div className="flex items-center">
      <div className="relative">
        <div
          className={`w-5 h-5 rounded-full flex items-center justify-center transition-colors duration-200
          ${isComplete ? 'bg-dualite-background-primary border-dualite-background-cta' : ''}
          ${isCurrent ? 'border-2 border-dualite-background-cta bg-transparent' : ''}
          ${!isComplete && !isCurrent ? 'border border-dualite-background-cta bg-transparent' : ''}`}
        >
          {isComplete ? (
            <div className="i-ph:check-bold w-3 h-3 text-dualite-background-cta" />
          ) : isCurrent ? (
            <div className="w-2 h-2 rounded-full bg-dualite-background-cta animate-pulse" />
          ) : null}
        </div>
      </div>
      <div className="ml-3">
        <p
          className={`text-sm font-medium transition-colors duration-200
          ${isComplete || isCurrent ? 'text-dualite-text-primary' : 'text-dualite-text-secondary'}`}
        >
          {label}
        </p>
      </div>
    </div>
  );
};
